import type { FilterFieldDef } from 'components/common/MasterFilter/smartFilterTypes';

const clientsFilterFields: FilterFieldDef[] = [
  // ─── Dates ───
  { backendField: 'createdAt', label: 'Fecha de creación', type: 'dateRange', group: 'Fechas' },
  { backendField: 'lastMessageDate', label: 'Último mensaje', type: 'dateRange', group: 'Fechas' },

  // ─── Enums ───
  { backendField: 'source', label: 'Origen', type: 'enum', dynamicOptionsKey: 'sources', group: 'Estado' },
  {
    backendField: 'aiSafetyStatus',
    label: 'Estado seguridad IA',
    type: 'enum',
    dynamicOptionsKey: 'aiSafetyStatuses',
    group: 'Estado',
  },
  {
    backendField: 'lastSentMessageRole',
    label: 'Rol último mensaje',
    type: 'enum',
    dynamicOptionsKey: 'messageRoles',
    group: 'Estado',
  },
  {
    backendField: 'lastLeadStatus',
    label: 'Último estado lead',
    type: 'enum',
    dynamicOptionsKey: 'leadStatuses',
    group: 'Estado',
  },

  // ─── Tags (topics) ───
  {
    backendField: 'topics',
    label: 'Tags',
    type: 'enum',
    dynamicOptionsKey: 'topics',
    group: 'Estado',
  },

  // ─── Booleans ───
  {
    backendField: 'disabledAutomaticResponses',
    label: 'Resp. automáticas deshabilitadas',
    type: 'boolean',
    group: 'Estado',
  },
  { backendField: 'hasValidName', label: 'Nombre validado', type: 'boolean', group: 'Estado' },

  // ─── Text ───
  {
    backendField: 'notes',
    label: 'Notas cliente',
    type: 'textSearch',
    group: 'Texto',
    visibleWhen: (ctx) => ctx.businessUnitId === 39,
  },

  // ─── Mueve Seguro only ───
  {
    backendField: 'clientAdvancePercentageBucket',
    label: 'Avance venta',
    type: 'enum',
    group: 'Métricas',
    options: [
      { value: '0-10', label: '0–10%' },
      { value: '10-20', label: '10–20%' },
      { value: '20-30', label: '20–30%' },
      { value: '30-40', label: '30–40%' },
      { value: '40-50', label: '40–50%' },
      { value: '50-60', label: '50–60%' },
      { value: '60-70', label: '60–70%' },
      { value: '70-80', label: '70–80%' },
      { value: '80-90', label: '80–90%' },
      { value: '90-100', label: '90–100%' },
    ],
    visibleWhen: (ctx) => ctx.businessUnitId === 39,
  },
  {
    backendField: 'insuranceProduct',
    label: 'Producto',
    type: 'enum',
    group: 'Métricas',
    options: [
      { value: 'loanProtectionInsurance', label: 'Desgravamen' },
      { value: 'unemploymentInsurance', label: 'Cesantía' },
    ],
    visibleWhen: (ctx) => ctx.businessUnitId === 39,
  },

  // ─── People ───
  {
    backendField: 'userId',
    label: 'Ejecutivo asignado',
    type: 'userReference',
    dynamicOptionsKey: 'assignedUser',
    group: 'Personas',
  },

  // ─── Numeric ───
  { backendField: 'unreadMessagesCount', label: 'Mensajes no leídos', type: 'numericRange', group: 'Métricas' },
  { backendField: 'messagesCount', label: 'Total mensajes', type: 'numericRange', group: 'Métricas' },
  { backendField: 'clientMessagesCount', label: 'Mensajes del cliente', type: 'numericRange', group: 'Métricas' },

  // ─── Car dealership only ───
  {
    backendField: 'lastCRMUpdate',
    label: 'Última actualización CRM',
    type: 'dateRange',
    group: 'Fechas',
    visibleWhen: (ctx) => ctx.businessUnitType === 'car_dealership',
  },
  {
    backendField: 'visitDate',
    label: 'Fecha de visita',
    type: 'dateRange',
    group: 'Fechas',
    visibleWhen: (ctx) => ctx.businessUnitType === 'car_dealership',
  },
  {
    backendField: 'brandOfInterest',
    label: 'Marca de interés',
    type: 'enum',
    dynamicOptionsKey: 'brands',
    group: 'Vehículos',
    visibleWhen: (ctx) => ctx.businessUnitType === 'car_dealership',
  },
  {
    backendField: 'clientType',
    label: 'Tipo de cliente',
    type: 'enum',
    group: 'Vehículos',
    options: [
      { value: 'buy', label: 'Compra' },
      { value: 'sell', label: 'Venta' },
      { value: 'after-sale', label: 'Post-venta' },
    ],
    visibleWhen: (ctx) => ctx.businessUnitType === 'car_dealership',
  },
  {
    backendField: 'branchOffice',
    label: 'Sucursal',
    type: 'enum',
    dynamicOptionsKey: 'branchOffices',
    group: 'Vehículos',
    visibleWhen: (ctx) => ctx.businessUnitType === 'car_dealership',
  },
  {
    backendField: 'requiresFinancing',
    label: 'Requiere financiamiento',
    type: 'boolean',
    group: 'Vehículos',
    visibleWhen: (ctx) => ctx.businessUnitType === 'car_dealership',
  },
  {
    backendField: 'creditStatus',
    label: 'Estado crédito',
    type: 'enum',
    dynamicOptionsKey: 'creditStatuses',
    group: 'Estado',
    visibleWhen: (ctx) => ctx.businessUnitType === 'car_dealership' || ctx.businessUnitType === 'financial_institution',
  },
  {
    backendField: 'endReason',
    label: 'Motivo de término',
    type: 'enum',
    dynamicOptionsKey: 'endReasons',
    group: 'Estado',
    visibleWhen: (ctx) => ctx.businessUnitType === 'car_dealership',
  },
];

export default clientsFilterFields;
